import css from "./Intro.module.css";

const Intro = ({ button, image, maxWidth, primary, secondary }) => {
  return (
    <>
      <div className="container background_gradient-bottom">
        <div className={`${css.main} center`}>
          <div className="column g1">
            <h1 className={css.ctext}>{primary}</h1>
            <p className={css.ctext}>{secondary}</p>
            <a
              className="cta"
              href="https://calendar.app.google/cgho9MaUp1oADCZLA"
              target="_blank"
              rel="noopener noreferrer"
            >
              {button || "Schedule a consultation"}
            </a>
          </div>
          <div className={css.img}>
            <img
              src={require("./anika.png")}
              alt="anika"
              className={css.anika}
            />
          </div>
        </div>
      </div>
      <img
        className="crystals_light"
        src={require("../../images/crystals_light.png")}
        alt="crystals"
      />
    </>
  );
};

export default Intro;
